import React from "react";

const ModalManager: React.FC = () => {
	// const dispatch = useDispatch();
	// const modalState = useSelector((state: RootState) => state.modal);

	return <></>;
};

export default ModalManager;
